import { render } from "./Fail.vue?vue&type=template&id=739ed806"
import script from "./Fail.vue?vue&type=script&lang=js"
export * from "./Fail.vue?vue&type=script&lang=js"
script.render = render

export default script